/* p11dz347 Canonical Social Architecture
   Operating Manual only. Duplicate alias/recovery templates removed.
   No Firebase/realtime/backend activation.
*/
(function(){
  window.DSDCanonicalSocialArchitecture347 = {
    version: "p11dz347",
    rule: "One system = one canonical surface",
    canonicalRoutes: ["/pages/notifications","/pages/messages","/pages/stories","/pages/persistence-registry"],
    aliasTemplatesRemoved: true,
    firebaseReads: false,
    firebaseWrites: false,
    realtime: false
  };
})();
